import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconFlashcards: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-2-IconFlashcards"><Path d="M3 8.04492L12.9452 6.99964L14.412 20.9549L4.46676 22.0002L3 8.04492Z" fill="currentColor"/><Path d="M21.1123 3.04492L19.6455 17.001L15.6611 16.5811L14.458 5.13184L10.7969 5.51562L11.167 2L21.1123 3.04492Z" fill="currentColor"/></CentralIconBase>;
});

export default IconFlashcards;
